module.exports = __webpack_public_path__ + "assets/18bf7dff-7b52-4a2c-8fcc-c7eac8f02636.4d9955a5.svg";